import * as folderService from './folderService'

// Which list a trivvy doc belongs to. Same keys the list pages register with
// makeFolderHandlers (REWARD has no folders).
export const getTrivvyCategory = (trivvy) => {
  if (trivvy && trivvy.triviaCategoryType === 'REWARD') {
    return 'REWARD'
  }
  if (trivvy && trivvy.isMessaging) {
    return 'MESSAGE'
  }
  if (trivvy && trivvy.triviaCategoryType === 'KNOWLEDGE_CHECK') {
    return 'KNOWLEDGE_CHECK'
  }
  return 'SURVEY'
}

// Appends ?folderId= so the list page re-opens that folder on arrival.
export const withFolderQuery = (path, folderId) => {
  if (!folderId) {
    return path
  }
  return (
    path +
    '?' +
    folderService.FOLDER_QUERY_PARAM +
    '=' +
    encodeURIComponent(folderId)
  )
}

// The list (and open folder) a trivvy doc should send the user back to.
export const getTrivvyListPath = (orgId, trivvy) => {
  if (!orgId || !trivvy) {
    return null
  }
  const category = getTrivvyCategory(trivvy)
  if (category === 'REWARD') {
    return '/home/trivia/' + orgId + '/rewards'
  }
  let endUrl = '/list'
  if (category === 'MESSAGE') {
    endUrl = '/messages'
  } else if (category === 'KNOWLEDGE_CHECK') {
    endUrl = '/kcs-list'
  }
  return '/home/trivia/' + orgId + withFolderQuery(endUrl, trivvy.folderId)
}
